export default {
    en: {
        admin: {
            company: {
                title: 'Companies',
                subtitle: 'Manage companies',
                creating: 'Creating Company',
                editing: 'Editing Company',
                showing: 'Showing Company',
                labels: {
                    razonSocial: 'Business Name',
                    cuit: 'CUIT',
                    nombreFantasia: 'Trade Name',
                    direccion: 'Address',
                    telefono: 'Phone',
                    emailComercial: 'Contact email (company)',
                    emailContacto: 'Email for sending credentials',
                    emailContactoShort: 'Email (credentials)',
                    emailContactoHint: 'Welcome message with created users and passwords is sent here (not necessarily the company contact email)',
                    active: 'Status',
                    afipActivo: 'AFIP Configuration',
                    afipConfigured: 'Configured',
                    afipNotConfigured: 'Not Configured',
                    updatedAt: 'Last Updated'
                }
            },
            inviraUser: {
                title: 'Invira Users',
                subtitle: 'Manage Invira users',
                creating: 'Creating Invira User',
                editing: 'Editing Invira User',
                showing: 'Showing Invira User',
                labels: {
                    username: 'Username',
                    email: 'Email',
                    password: 'Password',
                    company: 'Company',
                    role: 'Role',
                    depositos: 'Deposits',
                    active: 'Status',
                    updatedAt: 'Last Updated'
                }
            },
            inviraRole: {
                title: 'Invira User Roles',
                subtitle: 'Manage roles for Invira users',
                creating: 'Creating Role',
                editing: 'Editing Role',
                showing: 'Showing Role',
                deleting: 'Deleting Role',
                created: 'Role created',
                updated: 'Role updated',
                deleted: 'Role deleted',
                labels: {
                    users: 'Users',
                    permissions: 'Permissions',
                    username: 'Username',
                    email: 'Email',
                    company: 'Company',
                    role: 'Role',
                    roles: 'Roles',
                    active: 'Status',
                    name: 'Name',
                    childRoles: 'Child Roles',
                    updatedAt: 'Last Updated'
                }
            },
        },
        deposito: {
            title: 'Deposito',
            subtitle: 'View, search, create, edit and delete Deposito',
            creating: 'Creating Deposito',
            editing: 'Editing Deposito',
            deleting: 'Deleting Deposito',
            showing: 'Showing Deposito',
            labels: {
                nombre: 'name',
                direccion: 'address',
                descripcion: 'description',
                telefono: 'phone',
                email: 'email',
                responsable: 'responsible',
                activo: 'active'
            }
        }
    },
    es: {
        admin: {
            company: {
                title: 'Compañias',
                subtitle: 'Administrar compañias',
                creating: 'Creando Compañia',
                editing: 'Editando Compañia',
                showing: 'Mostrando Compañia',
                labels: {
                    razonSocial: 'Razón Social',
                    cuit: 'CUIT',
                    nombreFantasia: 'Nombre de Fantasía',
                    direccion: 'Dirección',
                    telefono: 'Teléfono',
                    emailComercial: 'Email de contacto (empresa)',
                    emailContacto: 'Email para envío de credenciales',
                    emailContactoShort: 'Email (credenciales)',
                    emailContactoHint: 'Aquí se envía el correo de bienvenida con usuarios y contraseñas; puede ser distinto al email de contacto de la empresa',
                    active: 'Estado',
                    afipActivo: 'Configuración AFIP',
                    afipConfigured: 'Configurado',
                    afipNotConfigured: 'No Configurado',
                    updatedAt: 'Última actualización'
                }
            },
            inviraUser: {
                title: 'Usuarios Invira',
                subtitle: 'Administrar usuarios Invira',
                creating: 'Creando Usuario Invira',
                editing: 'Editando Usuario Invira',
                showing: 'Mostrando Usuario Invira',
                labels: {
                    username: 'Usuario',
                    email: 'Email',
                    password: 'Contraseña',
                    company: 'Compañia',
                    role: 'Rol',
                    depositos: 'Depósitos',
                    active: 'Estado',
                    updatedAt: 'Última actualización'
                }
            },
            inviraRole: {
                title: 'Roles de Invira',
                subtitle: 'Administrar roles de usuarios de Invira',
                creating: 'Creando Rol',
                editing: 'Editando Rol',
                showing: 'Mostrando Rol',
                deleting: 'Eliminando Rol',
                created: 'Rol creado',
                updated: 'Rol actualizado',
                deleted: 'Rol eliminado',
                labels: {
                    users: 'Usuarios',
                    permissions: 'Permisos',
                    username: 'Usuario',
                    email: 'Email',
                    company: 'Compañia',
                    role: 'Rol',
                    roles: 'Roles',
                    active: 'Estado',
                    name: 'Nombre',
                    childRoles: 'Roles Hijos',
                    updatedAt: 'Última actualización'
                }
            }
        },
        deposito: {
            title: 'Administración de Depósitos',
            subtitle: 'Ver, buscar, crear, editar, y borrar Depósitos',
            creating: 'Creando Depósito',
            editing: 'Modificando Depósito',
            deleting: 'Eliminando Depósito',
            showing: 'Detalles de Depósito',
            labels: {
                nombre: 'nombre',
                direccion: 'dirección',
                descripcion: 'descripción',
                telefono: 'teléfono',
                email: 'email',
                responsable: 'responsable',
                activo: 'activo',
                updatedAt: 'Fecha última actualización'
            }
        }
    }
}

